const baseUrl: string = 'https://partform.cloud.readysize.ai/tiendanube/';

export default class BaseService {

    public static async PostServices(controller: string, action: string, data: any) {

        const respose = await fetch(`${baseUrl}${controller}/${action}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                //'Authorization': (StorageServices.GetCookieUser().TokenType ? StorageServices.GetCookieUser().TokenType + ' ' + StorageServices.GetCookieUser().Token : StorageServices.GetCookieUser().Token)
            },
            body: JSON.stringify(data)
        });

        return respose.json();
    }

    public static async PutServices(controller: string, action: string, data: any) {
        const respose = await fetch(`${baseUrl}${controller}/${action}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                //'Authorization': (StorageServices.GetCookieUser().TokenType ? StorageServices.GetCookieUser().TokenType + ' ' + StorageServices.GetCookieUser().Token : StorageServices.GetCookieUser().Token)
            },
            body: JSON.stringify(data)
        });

        return respose.json();
    }

    public static async GetServices(controller: string, action: string) {
        const respose = await fetch(`${baseUrl}${controller}/${action}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                //'Authorization': (StorageServices.GetCookieUser().TokenType ? StorageServices.GetCookieUser().TokenType + ' ' + StorageServices.GetCookieUser().Token : StorageServices.GetCookieUser().Token)
            }
        });

        return respose.json();
    }

    public static async DelServices(controller: string, action: string) {
        const respose = await fetch(`${baseUrl}${controller}/${action}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                //'Authorization': (StorageServices.GetCookieUser().TokenType ? StorageServices.GetCookieUser().TokenType + ' ' + StorageServices.GetCookieUser().Token : StorageServices.GetCookieUser().Token)
            }
        });

        return respose.json();
    }

    public static async PostAnonymousServices(controller: string, action: string, data: any) {
        const respose = await fetch(`${baseUrl}${controller}/${action}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        return respose.json();
    }

    public static async GetAnonymousServices(controller: string, action: string) {
        const respose = await fetch(`${baseUrl}${controller}/${action}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return respose.json();
    }

    public static async PostFileServices(controller: string, action: string, data: FormData) {
        const respose = await fetch(`${baseUrl}${controller}/${action}`, {
            method: 'POST',
            // headers: {
            //     'Authorization': (StorageServices.GetCookieUser().TokenType ? StorageServices.GetCookieUser().TokenType + ' ' + StorageServices.GetCookieUser().Token : StorageServices.GetCookieUser().Token)
            // },
            body: data
        })
        .catch((error) => { throw error});

        return respose.json();
    }

}